
import { uriCellRenderer, booleanCellRenderer, numberCellRenderer, imageCellRenderer, textCellRenderer } from "@glideapps/glide-data-grid";
import { GridCellKind } from "@glideapps/glide-data-grid";
// importing textCellRenderer from node module so if i edit in node module it will reflect here
// import {textCellRenderer} from "../../components/cells/text";
import { marked } from 'marked';
import DropdownCellRenderer from "../../components/cells/dropdown-cell.js";
// import ArticleCellRenderer from "../../components/cellsarticle-cell.js";
// import RangeCellRenderer from "../../components/cellsrange-cell.js";

import DatePickerRenderer from "../../components/cells/date-picker-cell.js";
// import LinksCellRenderer from "../../components/cellslinks-cell.js";
// import ButtonCellRenderer from "../../components/cellsbutton-cell.js";
// import TreeViewCellRenderer from "../../components/cellstree-view-cell.js";
import MultiSelectCellRenderer from "../../components/cells/multi-select-cell.js";
import JSONRenderer from "../../components/cells/json-cell.js";
import markdownCellRenderer from "../../components/cells/markdown-cell.js";
import _ from 'lodash'
const removeNewLines = (text) => text.replace(/\n+/g, ' ');
const markdownToText = (markdown) => {
    const html = marked(markdown);
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const text = doc.body.textContent || "";
    return removeNewLines(text);
  };
  
  
  
const getRenderer = (datatype) => {
    switch (datatype) {
        case 'url':
            return uriCellRenderer;
        case 'boolean':
            return booleanCellRenderer;
        case 'number':
            return numberCellRenderer;
        case 'text':
            return textCellRenderer;
        case 'longtext':
            return textCellRenderer
        case 'imageurl':
            return imageCellRenderer;
        case 'markdown':
            return markdownCellRenderer;
        case 'date':
            return DatePickerRenderer;
        case 'time':
            return DatePickerRenderer;
        case 'datetime-local':
            return DatePickerRenderer;
        case 'select':
            return DropdownCellRenderer;
        case 'multiSelect':
            return MultiSelectCellRenderer;
        case 'checkbox':
            return booleanCellRenderer;
        case 'Formula':
            return textCellRenderer;
        case 'json':
            return JSONRenderer;
        case 'email':
            return textCellRenderer;

        default:
            return textCellRenderer;
    }
}
export const getCellKind = (datatype, value, options, originalValue, image) => {
    if (datatype === 'date' || datatype === 'time' || datatype === 'datetime-local') {
        let displayDate = value ? new Date(value).toISOString() : '';
        if (datatype === 'date' && displayDate) {
            displayDate = new Date(value).toISOString().split("T")[0]
        }
        if (datatype === 'time' && displayDate) {
            displayDate = new Date(value).toISOString().split("T")[1].replace("Z", "")
        }

        return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: value ? value.toString() : '',
            data: {
                kind: "date-picker-cell",
                date: new Date(),
                displayDate,
                format: datatype,
            },
        }
    } else if (datatype === 'json') {
        return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: value ? JSON.stringify(value) : '',
            data: {
                kind: "json",
                value: value,
                originalValue: originalValue,
            },
        };
    }
    else if (datatype === 'markdown') {
        if(value && typeof value === 'object' && Object.hasOwnProperty.call(value, 'value')) {
            value = value.value;
        }
        const displayData = markdownToText(value);
        return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: value, 
            displayData,
            data: {
                kind: "markdown",
                value: value ?? '',
                displayData,
            },
        }
    }
    else if (datatype === 'select') {
        return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            readonly: false,
            copyData: value,
            data: {
                kind: "dropdown-cell",
                allowedValues: options ?? [],
                value: typeof value === 'object' ? JSON.stringify(value) : value,
            },
        }
    }
    else if (datatype === 'multiSelect') {
        const v = value && _.isArray(value) ? value : []
        const v2 = originalValue && _.isArray(originalValue) ? originalValue : []
        let v3 = []
        if (v.length > 0) {
            v3 = v
        } else if (v2.length > 0) {
            v3 = v2
        }
        return {
            kind: GridCellKind.Custom,
            allowOverlay: true,
            copyData: v.join(","),
            data: {
                kind: "multi-select-cell",
                values: v3,
                options: options ?? [],
                allowDuplicates: true,
                allowCreation: true,
                allowedValues: options ?? [],
            },
        };
    }
    else if (datatype === 'imageurl') {
        return {
            kind: GridCellKind.Image,
            data: [value],
            allowOverlay: true,
            readonly: true,
            copyData: value ? value.toString() : '',
        };
    }
    else if (datatype === 'profile') {
        return {
            kind: GridCellKind.Custom,
            copyData: value ? JSON.stringify(value) : '',
            data: {
                kind: "profile",
                value: value,
                image,
                name: value, 
                initial: value ? value[0] : '',
                tint: '#000000',
            },
            allowOverlay: true,
            readonly: true,
        };
    }
    else if (datatype === 'boolean') {
        return {
            kind: GridCellKind.Boolean,
            allowOverlay: true,
            copyData: value,
            data: !!value,
            readOnly: false,
        };
    }
    else if (datatype === 'url') {
        return {
            kind: GridCellKind.Uri,
            data: value,
            allowOverlay: true,
            hoverEffect: true,
            copyData: value ? value.toString() : '',
            onClickUri: () => {
                if(value&& !value.startsWith("http://") && !value.startsWith("https://")){
                    window.open(`https://${value}`, "_blank");
                }else{
                    window.open(value, "_blank");
                }
            },
        };
    }
    else if (datatype === 'Formula') {
        return {
            kind: GridCellKind.TextText,
            allowOverlay: true,
            data: value,
            copyData: value ? value.toString() : '',
            displayData: value ? value.toString() : '',
            readOnly: false,
        };
    }
    else if (datatype === 'email') {
        return {
            kind: GridCellKind.Text,
            allowOverlay: true,
            data: value,
            copyData: value ? value.toString() : '',
            displayData: value ? value.toString() : '',
            readOnly: false,
        };
    }
    else if (datatype === 'number') {
        return {
            kind: GridCellKind.Number,
            allowOverlay: true,
            data: value,
            copyData: value ? value.toString() : '',
            displayData: value ? value.toString() : '',
            readOnly: false,
        };
    }
    else if (datatype === 'text') {
        const displayData = markdownToText(value ? value.toString() : '');
        return {
            kind: GridCellKind.Text,
            allowOverlay: true,
            displayData,
            copyData: value ? value.toString() : '',
            data: value,
            readOnly: false,
        };
    } else if (value && typeof value === 'object') {
        return {
            kind: GridCellKind.Text,
            allowOverlay: true,
            data: value ? JSON.stringify(value) : '',
            displayData: value ? JSON.stringify(value) : '',
            copyData: value ? JSON.stringify(value) : '',
            readOnly: false,
        };
    }
    else {
        return {
            kind: GridCellKind.Text,
            allowOverlay: true,
            displayData: value ? value.toString() : '',
            copyData: value ? value.toString() : '',
            data: value,
            readOnly: false,
        };
    }
}
const getKind = (datatype) => {
    switch (datatype) {
        case 'url':
            return GridCellKind.Uri;
        case 'boolean':
            return GridCellKind.Boolean;
        case 'number':
            return GridCellKind.Number;
        case 'text':
            return GridCellKind.Text;
        case 'longtext':
            return GridCellKind.Text;
        case 'imageurl':
            return GridCellKind.Image;
        case 'markdown':
            return GridCellKind.Markdown;
        case 'date':
            return GridCellKind.Custom;
        case 'time':
            return GridCellKind.Custom;
        case 'datetime-local':
            return GridCellKind.Custom;
        case 'select':
            return GridCellKind.Custom;
        case 'multiSelect':
            return GridCellKind.Custom;
        case 'checkbox':
            return GridCellKind.Boolean;
        case 'Formula':
            return GridCellKind.Text;
        case 'json':
            return GridCellKind.Custom;
        case 'email':
            return GridCellKind.Text;
        default:
            return GridCellKind.Text;
    }
}
const infoIconSize = 12;
const makeClone = (cell, args) => {
    const { theme, rect } = args;
    const { datatype } = cell.data;
    const kind = getKind(datatype);
    const clonedArgs = { ...args }
    if (rect) {
        clonedArgs.rect = { ...rect, x: rect.x + infoIconSize + theme.cellHorizontalPadding };
    }
    const kindData = getCellKind(datatype, cell.data.value, cell.data.options, cell.data.originalValue);
    const clonedCell = {
        ...cell,
        ...kindData,
        kind,
        hoverEffect: true,
        contentAlign: 'left'
    };
    clonedArgs.cell = clonedCell;
    const renderer = getRenderer(datatype);
    return { args: clonedArgs, cell: clonedCell, kind, renderer, kindData };

}

export const cellDraw = (args, cell) => {
    try {
        args.ctx.font = args.theme.baseFontFull;
        args.ctx.fillStyle = "gray"; // red-600
        args.ctx.textAlign = "left";
        const { args: clonedArgs, cell: clonedCell, renderer } = makeClone(cell, args);
        return renderer.draw(clonedArgs, clonedCell);
    } catch (e) {
        console.log(e);
    }
}
export const cellClick = (args, cell) => {
    try {
        const { args: clonedArgs, cell: clonedCell, renderer } = makeClone(cell, args);
        if (renderer.onClickUri) {
            clonedCell.onClickUri = () => {
                window.open(cell.data.value, "_blank");
            }
        }
        if (renderer.onClick) {
            return renderer.onClick(clonedArgs, clonedCell, cell?.data?.cellId);
        }
    } catch (e) {
        console.log(e);
    }
}
export const provideCellEditor = cell => p => {
    try {
        const { cell: clonedCell, renderer, kindData } = makeClone(cell, p);
        if (kindData.kind === GridCellKind.Custom && kindData.data.kind !== undefined) {
            const nCell = {
                ...cell,
                ...kindData
            }
            const clonedP = { ...p, value: nCell, initialValue: nCell.data.data, displayValue: nCell.displayData };
            if (renderer && renderer.provideEditor) {
                const provider = renderer.provideEditor(clonedCell);
                if (provider && typeof provider === 'function') {
                    return provider(nCell);
                } else if (provider && provider.editor) {
                    return provider.editor(clonedP);
                }

            }
        } else {
            if (renderer && renderer.provideEditor) {
                if (typeof cell.data === 'object' && cell.data.rowId) {
                    cell.data = cell.data.value;
                }
                const provider = renderer.provideEditor(cell);
                if (provider && typeof provider === 'function') {
                    if (typeof p.value.data === 'object') {
                        p.value.data = p.value.data.value;
                    }
                    return provider(p);
                } else if (provider && provider.editor) {
                    if (typeof p.value.data === 'object' && p.value.data.rowId) {
                        p.value.data = p.value.data.value;
                    }
                    return provider.editor(p);
                }

            }
        }
    } catch (e) {
        console.log(e);
    }

}